import { luscinia } from '../../luscinia';
import { Column, ColumnFilter } from '../bootgridTypes';
import { AdvancedFilterTemplates } from './advancedFilterTemplates';
import { FilterComponent, FilterComponentState } from './filterComponent';

export class AdvancedFilterManager {
    private container: HTMLElement;
    private filtersContainer: HTMLElement;
    private submitButton: HTMLButtonElement;
    private addFilterButton: HTMLButtonElement;
    private errorContainer: HTMLElement;

    private filterComponents: FilterComponent[] = [];
    private columns: Column[];
    private filters: ColumnFilter[];

    private addFilterButtonHandler: (e: MouseEvent) => void;

    private config: AdvancedFilterManagerConfig;

    constructor(container: HTMLElement, config: AdvancedFilterManagerConfig) {
        this.container = container;
        this.columns = config.columns;
        this.filters = config.filters;
        this.config = config;

        this.addFilterButtonHandler = (e: MouseEvent) => {
            e.preventDefault();
            this.addFilterComponent();
            this.container.dispatchEvent(new Event('filter-manager-stateChanged'));
        };
    }
    render() {
        this.container.innerHTML = '';
        this.container.insertAdjacentHTML('afterbegin', AdvancedFilterTemplates.getAdvancedFilters(luscinia.config.culture));
        this.filtersContainer = this.container.querySelector('.filters-container') as HTMLElement;
        this.addFilterButton = this.container.querySelector('.add-filter-button') as HTMLButtonElement;
        this.submitButton = this.container.querySelector('button[type="submit"]') as HTMLButtonElement;
        this.errorContainer = this.container.querySelector('.error-container') as HTMLElement;

        this.addFilterButton.addEventListener('click', this.addFilterButtonHandler);
        this.submitButton.addEventListener('click', this.config.onSubmit);
        this.container.addEventListener('filter-manager-stateChanged', this.config.onStateChange);

        if (this.filters.length > 0) {
            this.filters.forEach((filter) => {
                this.addFilterComponent(filter);
            });            
        }
    }
    getColumns(): Column[] {
        return this.columns;
    }
    destroy() {
        this.container.remove();
    }
    addFilterComponent(filter?: ColumnFilter) {
        const filterContainer = document.createElement('div');
        filterContainer.classList.add('filter-container');

        const filterState: FilterComponentState = filter ? {
            selectedColumnId: filter.ColumnName,
            selectedFilter: filter.FilterValue,
            filterValues: filter.Values,
        } : undefined;

        const filterComponent = new FilterComponent(filterContainer, {
            columns: this.columns,
            filterComponentState: filterState,
            onStateChange: () => {
                this.container.dispatchEvent(new Event('filter-manager-stateChanged'));
            },
            onRemove: () => {
                this.filterComponents = this.filterComponents.filter((fc) => fc !== filterComponent);
            },
        });

        filterComponent.render();
        this.filtersContainer.appendChild(filterContainer);
        this.filterComponents.push(filterComponent);
        return filterComponent;
    }
    getColumnFilters(): ColumnFilter[] {
        let columnFilters: ColumnFilter[] = [];
        this.filterComponents.forEach((component) => {
            const filter = component.getFilter();
            if (filter) {
                columnFilters.push(filter);
            }
        });
        return columnFilters;
    }
    private displayGeneralError(value: string) {
        if (!this.errorContainer) return;

        const pEl = document.createElement('p');
        pEl.innerText = value;

        this.errorContainer.innerHTML = '';
        this.errorContainer.append(pEl);
        this.shake(this.errorContainer);
    }
    private shake(element: HTMLElement) {
        element.classList.add('shake-animation');
        setTimeout(() => {
            element.classList.remove('shake-animation');
        }, 500);
    }
    private clearErrorMessages() {
        if (this.errorContainer) {
            this.errorContainer.innerHTML = '';
        }
    }
}

export interface AdvancedFilterManagerConfig {
    onSubmit: () => void;
    onStateChange?: () => void;
    columns: Column[]; 
    filters?: ColumnFilter[];
}
